import { isWebWorkerSupported } from './web-worker';

const IMAGE_SIZE_1MB = 1024 * 1024;

export const getImageCompressionOptions = () => {
    return {
        maxWidthOrHeight: 1600,
        initialQuality: 0.8,
    };
};

/**
 * hierarchical compression，the image shown is compressed to 768px by the CDN service
 */
export const getImageCompressionOptionsV2 = (file: File, os?: string) => {
    let maxWidthOrHeight = 1600;
    const { type, size } = file;

    if (size > IMAGE_SIZE_1MB * 10) {
        // Very large files (> 10MB) compress to 800px
        maxWidthOrHeight = 800;
    } else if (size > IMAGE_SIZE_1MB * 5) {
        // Large files (5-10MB) compress to 1080px
        maxWidthOrHeight = 1080;
    } else if (size > IMAGE_SIZE_1MB * 2) {
        // Medium files (2-5MB) compress to 1280px
        maxWidthOrHeight = 1280;
    }

    // PNG files special handling
    if (type === 'image/png') {
        maxWidthOrHeight = Math.min(maxWidthOrHeight, 1280);
        if (size > IMAGE_SIZE_1MB * 1.5) {
            maxWidthOrHeight = Math.min(maxWidthOrHeight, 1080);
        }
    }

    // Android specific handling
    if (os === 'ANDROID') {
        maxWidthOrHeight = Math.min(maxWidthOrHeight, 1440);
    }
    
    return {
        maxWidthOrHeight,
        initialQuality: 0.8,
        useWebWorker: isWebWorkerSupported(),
    };
};
